import { render, staticRenderFns } from "./ManifestKasKecil.vue?vue&type=template&id=67303bfc&scoped=true&"
import script from "./ManifestKasKecil.vue?vue&type=script&lang=js&"
export * from "./ManifestKasKecil.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKasKecil.vue?vue&type=style&index=0&id=67303bfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67303bfc",
  null
  
)

export default component.exports